import React from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import HistoryIcon from '@mui/icons-material/History';
import PersonIcon from '@mui/icons-material/Person';
import GavelIcon from '@mui/icons-material/Gavel';

export default function ActivityFeed({ activities, title = "Recent Activity" }) {
    const navigate = useNavigate();

    const getActivityIcon = (status) => {
        switch (status) {
            case 'hired':
                return <GavelIcon className="activity_icon hired" />;
            case 'pending':
            default:
                return <PersonIcon className="activity_icon" />;
        }
    };

    const getActivityText = (activity) => {
        const companyName = activity.user?.company_name || 
            `${activity.user?.fname || ''} ${activity.user?.lname || ''}`.trim() || 
            'A contractor';
        
        switch (activity.status) {
            case 'hired':
                return `${companyName} was awarded the project`;
            case 'pending':
                return `${companyName} submitted a bid`;
            default:
                return `${companyName} updated their bid`;
        }
    };

    if (!activities || activities.length === 0) {
        return (
            <div className="dashboard_section">
                <div className="section_header">
                    <h3><HistoryIcon /> {title}</h3>
                </div>
                <div className="empty_state small">
                    <p>No recent activity to show.</p>
                </div>
            </div>
        );
    }

    return (
        <div className="dashboard_section">
            <div className="section_header">
                <h3><HistoryIcon /> {title}</h3>
            </div>
            <div className="activity_feed">
                {activities.map((activity) => (
                    <div 
                        key={activity.id} 
                        className="activity_item"
                        onClick={() => navigate(`/project-details/${activity.project_id}`)}
                    >
                        {getActivityIcon(activity.status)}
                        <div className="activity_content">
                            <p className="activity_text">{getActivityText(activity)}</p>
                            <span className="activity_project">
                                {activity.project?.project_name?.length > 30 
                                    ? `${activity.project.project_name.slice(0, 30)}...` 
                                    : activity.project?.project_name}
                            </span>
                            <span className="activity_time">
                                {moment(activity.created_at).fromNow()}
                            </span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
